"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingSubProjectError = void 0;
class MissingSubProjectError extends Error {
    constructor(subProject, allSubProjectNames) {
        const msg = !allSubProjectNames.length
            ? 'No projects found.'
            : `Found these projects: ${allSubProjectNames}`;
        super(`Specified sub-project not found: "${subProject}". ` + msg);
        this.name = 'MissingSubProjectError';
        this.subProject = subProject;
        this.allProjects = allSubProjectNames;
        Error.captureStackTrace(this, MissingSubProjectError);
    }
}
exports.MissingSubProjectError = MissingSubProjectError;
//# sourceMappingURL=missing-sub-project-error.js.map